<div>
  <icn-navbar-menu
    class="alert-types-list"
    [active]="true"
    [overrideWidth]="'100%'"
  >
    <!--  Body -->
    <div icn-navbar-menu-items class="list-group">
      <!--  Items -->
      <icn-navbar-menu-item
        [ngClass]="{ 'no-cursor': gapsReportStatus == 'NO ISSUES' }"
        (click)="showGapReport()"
      >
        <span icn-navbar-menu-item-header class="head">Gaps</span>
        <span
          icn-navbar-menu-item-content
          [ngClass]="{
            'no-issues': gapsReportStatus == 'NO ISSUES',
            'report-link': gapsReportStatus != 'NO ISSUES'
          }"
          >{{ gapsReportStatus }}</span
        >
      </icn-navbar-menu-item>
      <icn-navbar-menu-item
        [ngClass]="{
          'no-cursor': missingSubtitleReportAlertsStatus == 'NO ISSUES'
        }"
        (click)="showMissingSubtitleReport()"
      >
        <span icn-navbar-menu-item-header class="head">Missing Subtitles</span>
        <span
          icn-navbar-menu-item-content
          [ngClass]="{
            'no-issues': missingSubtitleReportAlertsStatus == 'NO ISSUES',
            'report-link': missingSubtitleReportAlertsStatus != 'NO ISSUES'
          }"
          >{{ missingSubtitleReportAlertsStatus }}</span
        >
      </icn-navbar-menu-item>
      <icn-navbar-menu-item
        [ngClass]="{
          'no-cursor': missingAudiosReportAlertsStatus == 'NO ISSUES'
        }"
        (click)="showMissingAudiosReport()"
      >
        <span icn-navbar-menu-item-header class="head"
          >Missing Audios Tracks</span
        >
        <span
          icn-navbar-menu-item-content
          [ngClass]="{
            'no-issues': missingAudiosReportAlertsStatus == 'NO ISSUES',
            'report-link': missingAudiosReportAlertsStatus != 'NO ISSUES'
          }"
          >{{ missingAudiosReportAlertsStatus }}</span
        >
      </icn-navbar-menu-item>

      <icn-navbar-menu-item
        [ngClass]="{
          'no-cursor': emptyContractsReportAlertsStatus == 'NO ISSUES'
        }"
        (click)="showEmptyContractsReport()"
      >
        <span icn-navbar-menu-item-header class="head">Empty Contracts</span>
        <span
          icn-navbar-menu-item-content
          [ngClass]="{
            'no-issues': emptyContractsReportAlertsStatus == 'NO ISSUES',
            'report-link': emptyContractsReportAlertsStatus != 'NO ISSUES'
          }"
          >{{ emptyContractsReportAlertsStatus }}</span
        >
      </icn-navbar-menu-item>
    </div>
  </icn-navbar-menu>
</div>
